import { component } from './component';
import { breadcrumb } from './breadcrumb';
import { unit } from './unit';
import { validation_errors } from './validation_errors';

export const shared = {
  component,
  breadcrumb,
  unit,
  validation_errors,

  template: {
    footer: {
      email: 'Электронный адрес'
    }
  },

  date: {
    last_mounth: 'Прошлый месяц',
    '3_mounths': '3 месяца',
    '6_mounths': '6 месяцев',
    year: 'год',
    all_period: 'Весь период'
  },

  error_page: {
    403: {
      title: 'Доступ запрещен',
      description: 'Мы работаем над этим'
    },
    404: {
      title: 'К сожалению, страница, которую вы ищете, не найдена.',
      description: 'Мы работаем над этим'
    },
    500: {
      title: 'Внутренняя ошибка сервера',
      description: 'Мы работаем над этим'
    },
    520: {
      title: 'Неизвестная ошибка',
      description: 'Мы работаем над этим'
    },

    link: {
      to_index: 'На главную'
    }
  },
  referrer: {
    old_version:
      'Старая версия личного кабинета больше не поддерживается. Пожалуйста, авторизуйтесь в новой версии, чтобы получить все преимущества нашего сервиса.'
  },
  errors: {
    incorrect_login: 'Некорректный логин или пароль',
    authorisation: 'Ошибка авторизации',
    input_form: 'Заполните форму',
    'The given data was invalid.': 'Некорректный запрос'
  },
  loading: 'Загрузка',
  select: 'Выбрать',
};
